export default __webpack_public_path__ + "static/media/mobile-banner.3c41ad0a.svg";